import { Check, Quote } from "lucide-react";

const BULLETS = [
  "Schulung vor dem ersten Kundengespräch",
  "Klare Gesprächsleitfäden und Verhaltensstandards",
  "Dokumentierte Beratungsqualität",
  "Regelmäßiges Feedback und Training",
  "Professionelle Außenwirkung beim Bürger",
  "Nachhaltige Kundenbeziehungen statt kurzfristiger Abschlüsse",
];

export default function Quality() {
  return (
    <section
      id="qualitaet"
      data-testid="quality-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left content */}
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0A3B2C] mb-4">
              Qualität ist kein Zufall.
            </div>
            <h2
              className="text-3xl md:text-5xl font-bold tracking-tight leading-[1.1] text-[#0A3B2C] mb-6"
              style={{ fontFamily: "Outfit, sans-serif" }}
              data-testid="quality-title"
            >
              Unser Qualitätsversprechen.
            </h2>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8 max-w-2xl">
              Direktvertrieb braucht Vertrauen – und Vertrauen braucht Qualität.
              Unsere Vertriebsmannschaft wird ausgebildet, begleitet und
              kontinuierlich weiterentwickelt.
            </p>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              {BULLETS.map((b, i) => (
                <li
                  key={i}
                  data-testid={`quality-bullet-${i}`}
                  className="flex items-start gap-3 text-sm md:text-base text-gray-700"
                >
                  <span className="mt-0.5 flex-shrink-0 h-5 w-5 rounded-full bg-[#0A3B2C] flex items-center justify-center">
                    <Check className="h-3 w-3 text-white" strokeWidth={3} />
                  </span>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right - quote card */}
          <div className="lg:col-span-5">
            <div
              data-testid="quality-quote-card"
              className="relative bg-[#0A3B2C] text-white rounded-3xl p-8 md:p-10 shadow-2xl overflow-hidden fd-grain"
            >
              <Quote className="absolute top-6 right-6 h-24 w-24 text-white/5" />
              <div className="relative">
                <div className="text-xs uppercase tracking-[0.2em] text-[#10B981] font-semibold mb-6">
                  Unser Anspruch
                </div>
                <p
                  className="text-2xl md:text-3xl font-medium leading-snug"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {"„Unser Ziel ist, dass Kunden mit einem guten Gefühl zum Abschluss kommen.\u201c"}
                </p>
                <div className="mt-8 pt-6 border-t border-white/10 flex items-center justify-between">
                  <div>
                    <div className="text-sm font-semibold">faktor-direkt</div>
                    <div className="text-xs text-white/60 mt-0.5">Team & Vertrieb</div>
                  </div>
                  <div className="text-4xl font-bold text-[#10B981]" style={{ fontFamily: "Outfit, sans-serif" }}>
                    Q<span className="text-white/40">.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
